const ApplicationCulture = (function () {

    const defaultNumberOptions = Object.freeze({ 
        style: "decimal",
        minimumFractionDigits: 0,
        maximumFractionDigits: 20,
        roundingMode: "trunc",
        useGrouping: false,
        signDisplay: "negative",
    });
    
    const pt_BR = "pt-BR";
    const pt_BR_currencyOptions = Object.freeze({ 
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        roundingMode: "trunc",
        useGrouping: true,
        signDisplay: "negative",
    });

    const ptBR_Number = Intl.NumberFormat(pt_BR, defaultNumberOptions);
    const ptBR_Currency = Intl.NumberFormat(pt_BR, pt_BR_currencyOptions);

    const ptBR_Culture = Object.freeze({
        Name: pt_BR,
        LCID: 1046,
        NumberIntl: ptBR_Number,
        CurrencyIntl: ptBR_Currency,
        CurrencySymbol: "R$",
        DecimalSeparator: ",",
        NumberGroupSeparator: ".",
    });

    //  VERIFICANDO CULTURAS SUPORTADAS - START >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
    //
    const cultures = [pt_BR];
    const supportedLocales = Intl.NumberFormat.supportedLocalesOf(
        cultures,
        [defaultNumberOptions, pt_BR_currencyOptions],
    );

    if ( !supportedLocales.includes(pt_BR) ) {
        throw new Error("O navegador não suporta a cultura 'Português (Brasil)'.")
    }

    const _supportedCultures = [ptBR_Culture];
    Object.freeze(_supportedCultures);
    //
    //  VERIFICANDO CULTURAS SUPORTADAS - END <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
    
    const _instance = {};
    
    Object.defineProperty(_instance, "Brazil", {
        get: () => ptBR_Culture,
        set: () => {throw TypeError("Assignment to readonly property.");}
    });
    Object.defineProperty(_instance, "Cultures", {
        enumerable: true,
        get: () => _supportedCultures,
        set: () => {throw TypeError("Assignment to readonly property.");}
    });
    Object.defineProperty(_instance, "DefaultCulture", {
        get: () => ptBR_Culture,
        set: () => {throw TypeError("Assignment to readonly property.");}
    });
    Object.defineProperty(_instance, "CurrentCulture", {
        //  A cultura do navegador é obtida na propriedade 'navigator.language'.
        //  Por enquanto é para sempre ser usado 'pt-BR', independente do que for definido pelo navegador.
        get: () => {return ptBR_Culture;},
        set: () => {throw TypeError("Assignment to readonly property.");}
    });
    
    Object.seal(_instance);

    return _instance;

})();

export default ApplicationCulture;